import { updateObject } from "../../shared/utility";
import { shutterbDashboardConstants, globalConstants } from "../../constants";

// getting the default actions name from defined constants via decomposition
const {
  IS_UPDATED,
  ADD_TO_PROFILE,
  IS_FILE_DELETED,
  GET_GALLERY_DATA,
  DELETE_FROM_GALLERY,
  GET_EVENT_DETAIL_BY_ID,
  GET_REELS_BY_EVENT_ID,
  GET_REELS_BY_EVENT_GROUP_ID,
} = shutterbDashboardConstants;

// default state
const initialState = {
  // item is an object of my portfolio details and events are event requests list
  events: [],
  sbMyEvents: [],
  sbMyPortfolio: {},
  sbMyInfo: {
    id: "",
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    secondaryPhoneNumber: "",
    location: [{ currentLocation: "" }],
  },
  isStripeConnectSubmitted: true,
  isStripeConnectStatus: true,
  isImageDeleted: false,
  isAddedToProfile: false,
  galleryData: {},
  reelEvents: [],
  changeRequestReelEvents: [],
  reelDetails: {
    reelDetails: [],
    reelQuestionAnswers: [],
  },
  eventDetailById: [],
  isUpdated: false,
  allReels: [],
};

// manupilating the state based on actions and returning the state
export const shutterbDashboard = (state = initialState, action) => {
  switch (action.type) {
    case shutterbDashboardConstants.GET_EVENT_REQUEST + globalConstants.SUCCESS:
      return updateObject(state, {
        events: action.data?.items?.event,
      });
    case shutterbDashboardConstants.PUT_EVENT_REQUEST + globalConstants.SUCCESS:
      const updatedEventList = {
        events: state.events.filter((e) => {
          return e.id !== action.data?.items?.eventId;
        }),
      };
      return updateObject(state, updatedEventList);
    case shutterbDashboardConstants.GET_SB_MY_EVENTS + globalConstants.SUCCESS:
      return updateObject(state, {
        sbMyEvents: action.data?.items?.event || [],
      });
    case shutterbDashboardConstants.TAb_CHANGED:
      return updateObject(state, {
        reelEvents: [],
        sbMyEvents: [],
        changeRequestReelEvents: [],
      });
    case shutterbDashboardConstants.GET_PORTFOLIO_REQUEST +
      globalConstants.SUCCESS:
      return updateObject(state, {
        sbMyPortfolio: action.data?.items,
      });
    case shutterbDashboardConstants.DELETE_IMG_REQUEST +
      globalConstants.SUCCESS:
      return updateObject(state, {
        ...state,
      });
    case shutterbDashboardConstants.GET_MY_INFO_REQUEST +
      globalConstants.SUCCESS:
      return updateObject(state, {
        sbMyInfo: action.data.items,
      });
    case shutterbDashboardConstants.GET_STRIPE_CONNECTED_STATUS_REQUEST +
      globalConstants.SUCCESS:
      return updateObject(state, {
        isStripeConnectSubmitted: action.data.detailsSubmitted,
        isStripeConnectStatus: action.data.chargesEnable,
      });
    case DELETE_FROM_GALLERY + globalConstants.SUCCESS:
      return updateObject(state, {
        isImageDeleted: true,
      });
    case DELETE_FROM_GALLERY + globalConstants.FAILURE:
      return updateObject(state, {
        isImageDeleted: false,
      });
    case IS_FILE_DELETED:
      return updateObject(state, {
        isImageDeleted: false,
      });
    case GET_GALLERY_DATA + globalConstants.SUCCESS:
      return updateObject(state, {
        galleryData: action.data.items,
      });
    case ADD_TO_PROFILE + globalConstants.SUCCESS:
      return updateObject(state, {
        isAddedToProfile: !state.isAddedToProfile,
      });
    case ADD_TO_PROFILE + globalConstants.FAILURE:
      return updateObject(state, {
        isAddedToProfile: !state.isAddedToProfile,
      });
    case shutterbDashboardConstants.GET_REEL_EVENTS + globalConstants.SUCCESS:
      const incomingItems = action.data?.items || [];
      const isFirstPage = action.data?.currentPage === 1;
      // Combine & deduplicate by `id`
      const combinedItems = isFirstPage
        ? incomingItems
        : [...(state.reelEvents || []), ...incomingItems];

      const uniqueItems = [
        ...new Map(
          combinedItems.map((item) => [item.eventGroupId, item])
        ).values(),
      ];

      return updateObject(state, {
        reelEvents: uniqueItems,
      });
    case shutterbDashboardConstants.GET_CHANGE_REQUEST_REEL_EVENTS +
      globalConstants.SUCCESS:
      return updateObject(state, {
        changeRequestReelEvents: [
          ...(state.changeRequestReelEvents || []),
          ...(action.data?.items || []),
        ],
      });

    case shutterbDashboardConstants.GET_REEL_DETAILS + globalConstants.SUCCESS:
      return updateObject(state, {
        reelDetails: action.data,
      });
    case GET_EVENT_DETAIL_BY_ID:
      return updateObject(state, {
        eventDetailById: action.data,
      });

    case IS_UPDATED:
      return updateObject(state, {
        isUpdated: action.data,
      });
    case GET_REELS_BY_EVENT_ID + globalConstants.SUCCESS:
    case GET_REELS_BY_EVENT_GROUP_ID + globalConstants.SUCCESS:
      return updateObject(state, { allReels: action.data.items });
    default:
      return state;
  }
};
